package fyi.moko.hotpl.domain.model

/** `sync_queue.entityType` for a place row; `entityId` is the place id. */
const val SYNC_ENTITY_PLACE = "PLACE"

/**
 * `sync_queue.entityType` for a photo file; `entityId` is the file name. UPSERT means "upload
 * the local file", DELETE means "remove the remote object". Only the latest action per file
 * is kept (see the platform queue impls) — an upload that never happened has nothing to delete.
 */
const val SYNC_ENTITY_PHOTO = "PHOTO"

data class SyncQueueItem(
    val queueId: Long,
    val entityType: String,
    val entityId: String,
    val action: SyncAction,
    val createdAt: Long
)
